<template>
  <div>
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3"></TitleCard>

    <a-card class="all-card-style">
      <img src="../../../contralimg/bg.png" class="intelligent-box" />
      <!-- 基础信息 -->
      <div class="all-box">
        <div class="title-box-v">
          <img
            src="../../../image/homePage/icon.png"
            alt
            style="width: 12px;height:15px;margin-right: 10px"
          />基础信息
        </div>
        <div class="border"></div>
        <div class="content-box">
          <div class="contont-part-box">
            <div class>场地</div>
            <div class>{{FeedingModel.cVariety}}</div>
          </div>
          <div class="contont-part-box">
            <div class>时间</div>
            <div class>{{FeedingModel.cFeedKinds}}</div>
          </div>
          <div class="contont-part-box">
            <div class>作物</div>
            <div class>{{FeedingModel.cFeedUnit}}</div>
          </div>
          <div class="contont-part-box">
            <div class>面积</div>
            <div class>{{FeedingModel.cSeedingSpecs}}</div>
          </div>
          <div class="contont-part-box">
            <div class>肥料</div>
            <div class>{{FeedingModel.lSeedingQty}}</div>
          </div>
        </div>
      </div>
      <!-- 基础信息 -->
      <!-- 灌溉信息 -->

      <div class="all-box-s">
        <div class="title-box-s">
          <img
            src="../../../image/homePage/icon.png"
            alt
            style="width: 12px;height:15px;margin-right: 10px"
          />实时监测灌溉信息
        </div>
        <div class="border"></div>
        <div class="content-box-s">
          <div class="contont-part-box" v-for="(item,index) in waterData.propertiesR" >
            <div class>{{item.name}}</div>
            <div class="name">
              {{item.dataValue}}
              <span class="unit"></span>
            </div>
          </div>
        </div>
      </div>
      <!-- 灌溉信息 -->
      <!-- 气象站环境参数信息 -->

      <div class="all-box-q">
        <div class="title-box-q">
          <img
            src="../../../image/homePage/icon.png"
            alt
            style="width: 12px;height:15px;margin-right: 10px"
          />气象站环境参数
        </div>
        <div class="border"></div>
        <div class="content-box-q">
          <div class="contont-part-box">
            <div class>大气压</div>
            <div class="name">
              {{weatherToday.pres}}
              <span class="unit">pa</span>
            </div>
            <div class>风向</div>
            <div class="name">
              {{weatherToday.wind.deg}}
              <span class="unit"></span>
            </div>
          </div>
          <div class="contont-part-box">
            <div class>空气温度</div>
            <div class="name">
              {{weatherToday.tmp.max}}
              <span class="unit">℃</span>
            </div>
            <div class>降水量</div>
            <div class="name">
              {{weatherToday.pcpn}}
              <span class="unit">mm</span>
            </div>
          </div>
          <div class="contont-part-box">
            <div class>相对湿度</div>
            <div class="name">
              {{weatherToday.hum}}
              <span class="unit">%</span>
            </div>
            <div class>降水概率</div>
            <div class="name">
              {{weatherToday.pop}}
              <span class="unit">%</span>
            </div>
          </div>
          <div class="contont-part-box">
            <div class>风速</div>
            <div class="name">
              {{weatherToday.wind.spd}}
              <span class="unit">ms</span>
            </div>
            <div class>风速</div>
            <div class="name">
              {{weatherToday.wind.sc}}
              <span class="unit">级</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 气象站环境参数信息 -->
      <!-- 右侧 -->
      <div class="right-box">
        <div class="video-title-box">
          <videoPlayer
            ref="videoPlayer"
            :options="videoOptions"
            class="vjs-custom-skin videoPlayer"
            style="width:50%;"
            :playsinline="true"
          />
          <div class="observe-box">
            <div class="observe-text">作物观测</div>
            <div class="observe-content">
              <div class="system-text">灌溉系统</div>
              <div class="observe-contont-part-box">
                <div class>高度：</div>
                <div class="name">
                  10
                  <span class="unit">cm</span>
                </div>
              </div>
              <div class="observe-contont-part-box">
                <div class>平均重量：</div>
                <div class="name">
                  100
                  <span class="unit">g</span>
                </div>
              </div>
              <div class="observe-contont-part-box">
                <div class>健康状况：</div>
                <div class="name">
                  良好
                  <span class="unit"></span>
                </div>
              </div>
              <div class="observe-contont-part-box">
                <div class>灌溉量：</div>
                <div class="name">
                  5
                  <span class="unit">cm</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="irrigate-box">
          <div class="top-box-part">
            <div class="top-box-i">
              <img src="../../../image/homePage/icon.png" class="shu-icon-i" />
              <div class="top-big-text-i">灌溉需求分析</div>
              <div class="top-right-box-i">
                <div class="heng-line-i"></div>
              </div>
            </div>

            <div class="irrigate-text">分析结果：作物水分缺失，需及时灌溉。</div>
          </div>
          <!-- <div class="top-box-part"> -->
            <div class="top-box-i">
              <img src="../../../image/homePage/icon.png" class="shu-icon-i" />
              <div class="top-big-text-i">灌溉成分管理</div>
              <div class="top-right-box-i">
                <div class="heng-line-i"></div>
              </div>
            </div>

            <div class="irrigate-text">灌溉成分：氨80%、氨80%、氨80%、氨80%、氨80%、氨80%、氨80%、氨80%、氨80%、氨80%、氨80%、氨80%、氨80%、氨80%、氨80%、</div>
          <!-- </div>
          <div class="top-box-part"> -->
            <div class="top-box-i">
              <img src="../../../image/homePage/icon.png" class="shu-icon-i" />
              <div class="top-big-text-i">灌溉策略生成</div>
              <div class="top-right-box-i">
                <div class="heng-line-i"></div>
              </div>
            </div>

            <div class="irrigate-text">灌溉成分：2020年9月30日进行下一次灌溉，氨80%、氨80%、氨80%、氨80%、氨80%、氨80%、氨80%、氨80%、氨80%；</div>
          </div>
        </div>
      <!-- </div> -->
      <!-- 右侧 -->
    </a-card>
  </div>
</template>
<script>
  // @ is an alias to /src
  import TitleCard from '@/components/TitleCard.vue'
  import { _getDevicePropData } from '@/common/request'

  import 'video.js/dist/video-js.css'
  import 'vue-video-player/src/custom-theme.css'
  import { videoPlayer } from 'vue-video-player'
  import 'videojs-flash'




  const columns = [

    {
      title: '所属场地',
      dataIndex: 'scene',
      key: 'scene',
    },
    {
      title: '溶解氧',
      dataIndex: 'dissolvedOxygen',
      key: 'dissolvedOxygen',
    },
    {
      title: '水温',
      dataIndex: 'waterTemperature',
      key: 'waterTemperature',
    },
    {
      title: '浊度',
      dataIndex: 'turbidity',
      key: 'turbidity',
    },
    {
      title: '视频',
      dataIndex: 'video',
      key: 'video',
    },
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' },
    },
  ];

  const data = [
    {
      key: '1',
      scene:'场地一',
      dissolvedOxygen:'98%',
      waterTemperature:'26.2℃',
      turbidity:'95%',
      video:'视频一',
    },
    {
      key: '2',
      scene:'场地一',
      dissolvedOxygen:'98%',
      waterTemperature:'26.2℃',
      turbidity:'95%',
      video:'视频一',
    },
    {
      key: '3',
      scene:'场地一',
      dissolvedOxygen:'98%',
      waterTemperature:'26.2℃',
      turbidity:'95%',
      video:'视频一',
    },

    {
      key: '4',
      scene:'场地一',
      dissolvedOxygen:'98%',
      waterTemperature:'26.2℃',
      turbidity:'95%',
      video:'视频一',
    },

    {
      key: '5',
      scene:'场地一',
      dissolvedOxygen:'98%',
      waterTemperature:'26.2℃',
      turbidity:'95%',
      video:'视频一',
    },
  ];

  export default {
    name: 'seedingList',
    components: {
      TitleCard,
      videoPlayer
    },
    data() {
      return {
        weatherToday:{
          cloud: "",
          date: "",
          hum: "",
          pcpn: "",
          pop: "",
          pres: "",
          tmp: {
            max: "",
            min: ""
          },
          uv: "",
          vis: "",
          wind: {
            deg: "",
            dir: "",
            sc: "",
            spd: ""
          }
        },
        titleMsg1:"精准投喂",
        titleMsg2:'精准投喂',
        titleMsg3:'精准投喂',
        data,
        columns,
        waterData:{
          queryInfo:{
            productkey:"",
            devicename:"",
            limit:1
          },
          devices:{},
          propertiesR:[],
          data:{},
          timer: ''//定时器
        },
        waterdatatime:'',
        pflVisible:false,
        pagination: {
          onChange: page => {
            console.log(page);
          },
          pageSize: 5,
        },
        cEntID:'',
        cSceneID:'',

        FeedingModel:{},
        videoOptions: {

        }

      }
    },
    mounted () {
      let that=this;
      that.cEntID=that.$store.getters.User.enterprise.ID;
      that.cSceneID=that.$store.getters.SCene.ID;
      that.getDeviceData();
      that.getFeedingInfo();
      that.$bus.$on('scenechange',(target)=> {
        that.cSceneID=target.id;
        that.getDeviceData();
        that.getFeedingInfo();
      });

      that.weatherList();
    },
    methods:{
      toAddPage(){
        this.$router.push({path:'/preciseFeeding/preciseFeedingForm'});

      },
      showCard:function (){
        this.pflVisible=true
      },


      // 天气
      async weatherList(){
        let that=this;
        let res= await that.$http.get('WLWDevice/GetWeather',{})
        if(res.data.code=="200"){
          // console.log(res.data.message)
          let weatherList = JSON.parse(res.data.message);
          let weatherList1 = weatherList.result.HeWeather5[0].daily_forecast;

          that.weatherToday = weatherList1[0];
          console.log(that.weatherToday)
        }
        else{
          that.$message.error(res.message)

        }
      },


      async getFeedingInfo(){
        let that=this;
        let param=null;
        let res= await that.$http.post('EntSceneInfo/FindFeedingById?id='+that.cSceneID+'&cEntID='+that.cEntID,param)
        console.log('that.videodata.cVideoFlashUrl',res);
        if(res.data.code=="200"){
          that.FeedingModel= res.data.obj.data;

          console.log('that.FeedingModel.cVideoFlashUrl',that.FeedingModel.cVideoFlashUrl);

          that.videoOptions=    {
            playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
              autoplay: true, //如果true,浏览器准备好时开始回放。
            muted: false, // 默认情况下将会消除任何音频。
            loop: false, // 导致视频一结束就重新开始。
            preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            language: 'zh-CN',
            aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            techOrder: ['flash', 'html5'],      // 兼容顺序
            sources: [{ // 流配置，数组形式，会根据兼容顺序自动切换
            type: 'rtmp/hls',
            src:that.FeedingModel.cVideoFlashUrl
          }],
            poster: "", //你的封面地址
            // width: document.documentElement.clientWidth,
            notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
            controlBar: {
            timeDivider: true,
              ProgressControl:false,
              durationDisplay: true,
              remainingTimeDisplay: false,    ProcessBar: false,
              progressControl: false,
              autoDisable: true,
              fullscreenToggle: true  //全屏按钮
          }
          }
        }
        else{
          that.$message.error(res.message)

        }
      },
      async getDeviceData(){
        let _this=this;
        var waterlist=_this.$store.getters.Devices.filter(x=>x.cSceneID==_this.cSceneID&&x.ProductKey=='a1QdayAsVWc'&&x.cEntID==_this.cEntID)

        if(waterlist[0]!=null) {
          _this.waterData.devices=waterlist[0]
          var  ThingModels=_this.$store.getters.ThingModels.filter(x=>x.productKey==_this.waterData.devices.ProductKey)
          if(ThingModels!=null && ThingModels.length>0){
            var propertiesR=_this.utils.deepClone(ThingModels[0].propertiesR)
            if(propertiesR&&propertiesR.length>8){
              _this.waterData.propertiesR=propertiesR.splice(0,8)
            }else {
              _this.waterData.propertiesR=propertiesR
            }

          }
          _this.waterData.queryInfo.productkey=_this.waterData.devices.ProductKey
          _this.waterData.queryInfo.devicename=_this.waterData.devices.DeviceName
          _this.getWaterData()
        }

      },

      async getWaterData(){
        var data=await this.getDevicePropData(this.waterData.queryInfo)
        if(data!=null && data.length>0)
        {
          var dataItems=data[0].dataItems
          this.waterdatatime=data[0].gmtCreateDes;
          if (this.waterData.propertiesR&&this.waterData.propertiesR.length>3){
            this.waterData.propertiesR=this.waterData.propertiesR.slice(0,3)
          }

          this.waterData.propertiesR.forEach(element => {

            if(dataItems[element.identifier]!=null){
              var value=this.utils.formatPropData(element,dataItems[element.identifier].value)
              this.$set(element,"dataValue",value)
            }
          })
        }
      },
      async getDevicePropData(param){
        const res=await _getDevicePropData(this,param)
        if(res!=null){
          return res.obj.list
        }
        else{
          this.$message.error(res.message)
          return new []
        }
      },
    }
  }
</script>

<style>
.intelligent-box {
  position: relative;
  top: 10%;
  left: 25%;
  height: 255px;
  width: 43%;
}
.border {
  border: 1px solid rgba(68, 171, 234, 0.2);
}
.all-box {
  border: 1px solid rgb(68, 171, 234);
  position: relative;
  left: 0%;
  top: -250px;
  width: 23%;
  height: 245px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background: rgba(9, 52, 95, 0.57);
  border-radius: 3px;
}
.title-box-v {
  position: relative;
  left: -30%;
  top: 1%;
  width: 100%;
  height: 19%;
  display: flex;
  /* border-bottom: 1px solid rgba(68, 171, 234, 0.2); */
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  color: #1371c9;
  font-size: 110%;
  font-weight: 700;
}
.content-box {
  position: relative;
  left: 1%;
  top: 0%;
  width: 93%;
  height: 80%;
  display: flex;
  /* border: 1px solid #ffffff; */
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.single-box {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 90%;
  /* margin: 16px 0; */
  color: rgba(255, 255, 255, 0.7);
  z-index: 99;
}
.contont-part-box {
  display: flex;
  flex-direction: row;
  width: 96%;
  justify-content: space-between;
}
/* jiance */
.title-box-s {
  position: relative;
  left: -21%;
  top: 1%;
  width: 100%;
  height: 19%;
  display: flex;
  /* border-bottom: 1px solid rgba(68, 171, 234, 0.2); */
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  color: #1371c9;
  font-size: 110%;
  font-weight: 700;
}
.content-box-s {
  position: relative;
  left: 1%;
  top: 0%;
  width: 93%;
  height: 80%;
  display: flex;
  /* border: 1px solid #ffffff; */
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.all-box-s {
  border: 1px solid rgb(68, 171, 234);
  position: relative;
  left: 45%;
  top: -221px;
  width: 23%;
  height: 245px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background: rgba(9, 52, 95, 0.57);
  border-radius: 3px;
}
/* 气象环境 */
.title-box-q {
  position: relative;
  left: -36%;
  top: 1%;
  width: 100%;
  height: 19%;
  display: flex;
  /* border-bottom: 1px solid rgba(68, 171, 234, 0.2); */
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  color: #1371c9;
  font-size: 110%;
  font-weight: 700;
}
.content-box-q {
  position: relative;
  left: 1%;
  top: 0%;
  width: 93%;
  height: 80%;
  display: flex;
  /* border: 1px solid #ffffff; */
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.all-box-q {
  border: 1px solid rgb(68, 171, 234);
  position: relative;
  left: 0%;
  top: -465px;
  width: 43%;
  height: 245px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background: rgba(9, 52, 95, 0.57);
  border-radius: 3px;
}
.right-box {
  height: 510px;
  width: 29%;
  background: #00152a;
  border-color: #1a537e;
  position: relative;
  top: -985px;
  left: 70.5%;
  border: 1px solid rgb(68, 171, 234);
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.picture {
  width: 225px;
  height: 150px;
}
.video-title-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 95%;
  justify-content: space-around;
  align-content: center;

  margin-top: 15px;
  margin-left: 10px;
}
.observe-content {
  background-color: #013e75;
  height: 78%;
  width: 95%;
  border:1px solid #1C5380;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-content: center;

}
.observe-contont-part-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  width: 90%;
  justify-content: space-between;
  font-size: 80%;
  color: #a4b2c5;
  margin-left: 5px;
}
.observe-box {
  background-color: #004392;
  width: 32%;
   justify-content: center;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;

}
.observe-text {
  height: 18%;
  display: flex;
  margin-left: -51px;
  margin-top: 10px;

}

.top-box-i {
  width: 100%;
  display: flex;
  align-content: flex-end;
  justify-content: flex-end;
  flex-direction: row;
  align-items: flex-end;
  /* justify-content: space-between; */

  margin-top: 20px;
}
.heng-line-i {
  width: 100%;
  height: 1px;
  background-color: #075a8c;
}
.top-big-text-i {
  font-size: 115%;
  color: #1587e0;
  margin-left: 20px;
  width: 35%;
}
.top-right-box-i {
  margin-left: 10px;
  width: 50%;
}
.shu-icon-i {
  height: 14px;
  width: 11px;
}
.system-text {
  height: 25%;
  margin-left: 3px;
}
.irrigate-box {
  /* height: 70%; */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-top: -25px;
}
/* .top-box-part {
  height: 33.3%;
  display: flex;
  flex-direction: column;
} */
.irrigate-text {
  margin-top: 10px;
  /* display: flex;
  justify-content: center; */
  width: 84%;
  margin-left: 50px;

}
.name{
    color: #4DB7D4;
}
</style>
